module.exports = __webpack_public_path__ + "static/media/work.faccbd26.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/work.jpg
// module id = 33
// module chunks = 0